import { useEffect, useState, useCallback, useLayoutEffect } from 'react';

import './Carousel.css';

import { useTranslation } from 'react-i18next';

import { getImagesItems } from '../../shared/util/getImagesItems';
import CarouselItem from './CarouselItem';

function Carousel({ ariaHidden = false, isAnimationPaused }) {
  const { t } = useTranslation();
  const translatedImagesList = getImagesItems(t);

  const [activeIndex, setActiveIndex] = useState(0);
  const [items] = useState(translatedImagesList);
  const [activeItem, setActiveItem] = useState(translatedImagesList[0]);
  const [margin, setMargin] = useState<number>();

  const recalculateWidth = useCallback(() => {
    const container = document.getElementById('left_container');
    if (container) {
      const width = container.clientWidth;
      const indent = (860 - width) / 2;
      setMargin(-indent);
    }
  }, []);

  useLayoutEffect(() => {
    recalculateWidth();
    window.addEventListener('resize', recalculateWidth);
    return () => window.removeEventListener('resize', recalculateWidth);
  }, [recalculateWidth]);

  const updateIndex = useCallback(
    (newIndex) => {
      const normalizedIndex = (newIndex + items.length) % items.length;
      setActiveIndex(normalizedIndex);
      setActiveItem(items[normalizedIndex]);
    },
    [items]
  );

  useEffect(() => {
    let timer;
    if (!isAnimationPaused) {
      timer = setTimeout(() => updateIndex(activeIndex + 1), 6000);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [activeIndex, updateIndex, isAnimationPaused]);

  return (
    <div
      className="carousel_wrapper"
      role="region"
      aria-label={t('Carousel region')}
      aria-hidden={ariaHidden}
    >
      <div className="carousel">
        <div className="inner" style={{ marginLeft: margin }}>
          <CarouselItem
            key={activeIndex}
            activeItem={activeItem}
            isAnimationPaused={isAnimationPaused}
          />
        </div>
      </div>
    </div>
  );
}

export default Carousel;
